export default __webpack_public_path__ + "static/lead-bg@1x-8b60dadf2e0fddea8407b639e84a49c8.jpg";